<template lang="pug">
  #app
    transition(name="fade" mode="out-in")
      router-view.view
    app-dialog
    app-up-dialog
</template>

<script>
import appDialog from '@/components/dialog/dialog'
import appUpDialog from '@/components/dialog/upDialog'
import createStyle from './assets/style'
export default {
  name: 'app',
  data () {
    return {
      selected: 'zh',
      classes: createStyle('zh'),
    }
  },
  methods: {
    change () {
      this.classes = createStyle(this.selected)
    },
  },
  components: {
    appDialog,
    appUpDialog,
  },
  mounted () {
    window.test = 1
  },
}
</script>

<style lang="scss">
@import './assets/style/common.sass';

#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .header {
    height: 50px;
  }
  .main {
    flex: 1;
    display: flex;

    // min-width: 1300px;
    // min-height: 900px;
    .slider {
      width: 150px;
    }
    .view {
      flex: 1;
    }
  }
}
</style>
